import styled from 'styled-components';

export const ErrorMessage = styled.div`
  background: red;
  padding: 10px;
  border-radius: 10px;
`;

export const SuccessMessage = styled.p`
  display: flex;
  align-items: center;
  margin: 0.5em 0px;
  padding: 12px 16px;
  background-color: #28a745;
  color: white;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  gap: 8px;

  &::before {
    content: '✓';
    font-size: 16px;
  }
`;

export const ErrorText = styled.p`
  display: flex;
  align-items: center;
  margin: 0.5em 0px;
  padding: 12px 16px;
  background-color: #dc3545;
  color: white;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  gap: 8px;

  &::before {
    content: '⚠';
    font-size: 16px;
  }
`;
